// storageConfig.js
// Phase 4: Feature flag for storage backend.
// Set USE_SUPABASE = true to use Supabase.
// Set USE_SUPABASE = false to revert to localStorage instantly.
export const USE_SUPABASE = true;
